import React from 'react';
import CfbInlineTeamChip from './CfbInlineTeamChip';

export type CfbMatchupChipsProps = {
  awayLabel: string;
  homeLabel: string;
  awaySchoolId?: string | null;
  homeSchoolId?: string | null;
  separator?: '@' | 'vs';
  size?: 'sm' | 'md';
  showLabels?: boolean;
  className?: string;
};

const CfbMatchupChips: React.FC<CfbMatchupChipsProps> = ({
  awayLabel,
  homeLabel,
  awaySchoolId,
  homeSchoolId,
  separator = 'vs',
  size = 'sm',
  showLabels = false,
  className = '',
}) => {
  return (
    <span
      className={`inline-flex flex-wrap items-center gap-2 ${className}`.trim()}
      data-testid="cfb-matchup-chips"
    >
      <CfbInlineTeamChip label={awayLabel} schoolId={awaySchoolId} size={size} showLabel={showLabels} />
      <span className="text-secondary-500 text-xs font-medium" aria-hidden="true">
        {separator}
      </span>
      <CfbInlineTeamChip label={homeLabel} schoolId={homeSchoolId} size={size} showLabel={showLabels} />
    </span>
  );
};

export default CfbMatchupChips;
